export enum RatesApiRoutes {
  PlanPaymentDetailsCalculate = '/rates/plan-payment-details/calculate',
  PlanExpirationDetailsCalculate = '/rates/plan-expiration-details/calculate',
  Search = '/rates/search',
  ZipcodeDetails = '/rates/zipcode-details/:id',
  Defaults = '/rates/search/defaults',
  PlanDetails = '/rates/search/plan-details',
}
